/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { TagIdentifier } from '../models/TagIdentifier';
import type { TagType } from '../models/TagType';
import type { VehicleId } from '../models/VehicleId';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class TagsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * List a vehicle's tags
     * List a vehicle's tags
     * @param vehicleId Vehicle ID
     * @returns any Tags
     * @throws ApiError
     */
    public tagList(
        vehicleId: string,
    ): Observable<Array<{
        identifier: TagIdentifier;
        type: TagType;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/tags/',
            query: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Provision a tag for a vehicle
     * Register a tag against vehicle
     * @param requestBody
     * @returns any Tag registered
     * @throws ApiError
     */
    public tagCreate(
        requestBody: {
            identifier: TagIdentifier;
            type: TagType;
            vehicle_id: VehicleId;
        },
    ): Observable<{
        identifier: TagIdentifier;
        type: TagType;
        vehicle_id: VehicleId;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/tags/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Already registered`,
                500: `Server error`,
            },
        });
    }
    /**
     * Resolve tag to a vehicle
     * Verify tag and resolve it to a vehicle
     * @param tagId Tag identifier
     * @param ctr Read counter mirror
     * @param cmac CMAC
     * @returns any Vehicle and the deadline for redeeming this read
     * @throws ApiError
     */
    public tagResolve(
        tagId: string,
        ctr: string,
        cmac: string,
    ): Observable<{
        expires_at: string;
        vehicle_id: VehicleId;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/tags/{tag_id}',
            path: {
                'tag_id': tagId,
            },
            query: {
                'ctr': ctr,
                'cmac': cmac,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `Not found`,
                410: `Tag expired`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Revoke a tag from its vehicle
     * Revoke a tag from its vehicle
     * @param tagId Tag identifier
     * @returns void
     * @throws ApiError
     */
    public tagRevoke(
        tagId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/tags/{tag_id}',
            path: {
                'tag_id': tagId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
